import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DynamicFormComponent } from "../../common/dynamic-form/dynamic-form.component";

@Component({
  selector: "app-application-create-modal",
  standalone: true,
  imports: [CommonModule, DynamicFormComponent],
  templateUrl: "./application-create-modal.component.html",
  styleUrl: "./application-create-modal.component.scss",
})
export class ApplicationCreateModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  dynamicForm: any = new FormGroup({});
  @Input() fields: any = [];
  @Input() configs: any = {
    title:"",
    saveBtnText:""
  };
  @Input() onFieldChange?: (field: any, value: any) => void;
  isActive: boolean = false;

  ngOnInit(): void {
    //
  }

  /**
   * Handle field value changes from dynamic form
   */
  handleFieldChange(event: { field: any; value: any }): void {
    if (this.onFieldChange) {
      this.onFieldChange(event.field, event.value);
    }
  }

  create() {
    this.activeModal.close({
      value: this.dynamicForm.value,
      fields: this.fields,
    });
  }
}
